<div>
  <h2 i18n>
    <a [routerLink]="['/']">
      <i class="fa-solid fa-house fa-xs page-name-separator" aria-hidden="true"></i>
    </a>
    {{usageLabel}}
  </h2>
</div>

<div class="center">
  <iui-messages mode="alert" class="ms-auto me-auto"></iui-messages>
</div>


<div *ngIf="account" class="ui-g">
  <div class="ui-g-2 usgae-account-info">
    <strong>Company name: </strong>{{account.companyName}}
  </div>
  <div class="ui-g-2 usgae-account-info">
    <strong>SPID: </strong>{{account.spid}}
  </div>
</div>

<div *ngIf="summaryData">
  <h5 class="usage-header">Monthly Invoice Summary</h5>
  <div class="ui-g">
    <div class="ui-g-9">
      <p-table
        [columns]="summaryHeaders"
        [styleClass]="'btable'"
        [value]="summaryData"
        id="usage-summary-table"
      >

        <ng-template pTemplate="header" let-columns>
          <tr>
            <th class="usage-tbl-header" [style.width.%]="col.width" *ngFor="let col of columns">
              {{col.header}}
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" class="usage-tbl-body" let-summary>
          <tr>
            <td>{{summary.month}}</td>
            <td>{{summary.totalQueries | number}}</td>
            <td>{{summary.totalResults | number}}</td>
            <td>{{summary.invoiceNumber}}</td>
            <td>{{summary.invoiceAmount | currency}}</td>
            <td>{{summary.amountDue}}</td>
            <td>{{summary.invoiceStatus}}</td>
            <td>{{summary.paidDate}}</td>
          </tr>
        </ng-template>


      </p-table>

    </div>
  </div>
</div>

<h5 class="usage-header">Monthly Usage and Query Results Summary</h5>
<div class="ui-g">

  <div class="ui-g-9">


    <p-table
      [columns]="usageHeaders"
      [styleClass]="'btable'"
      [value]="usageData"
      id="usage-table"
      dataKey="month"
    >

      <ng-template pTemplate="header" let-columns>
        <tr>
          <th class="usage-tbl-header" [style.width.%]="col.width" *ngFor="let col of columns">
            {{col.header}}
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" class="usage-tbl-body" let-usage let-expanded="expanded">
        <tr>
          <td>
            <a href="#" [pRowToggler]="usage">
              <i [ngClass]="expanded ? 'fa fa-minus-circle' : 'fa fa-plus-circle'"></i>
            </a>
          </td>
          <td>{{usage.month}}</td>
          <td>
            {{usage.tnResults+usage.tnFileResults+usage.tnRangeResults+usage.codeResults+usage.npbResults | number}}
          </td>
          <td>{{usage.tnResults | number}}</td>
          <td>{{usage.tnFileResults | number}}</td>
          <td>{{usage.tnRangeResults | number}}</td>
          <td>{{usage.codeResults | number}}</td>
          <td>{{usage.npbResults | number}}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="rowexpansion" let-usage let-columns="usageHeaders">
        <tr>
          <td [attr.colspan]="usageHeaders.length + 1" *ngIf="usage.users" id="usage-expansion">

            <table id="usage-expansion-table">
              <tr *ngFor="let userName of Object.keys(usage.users)">
                <td [style.width.%]="usageHeaders[0].width"></td>
                <td [style.width.%]="usageHeaders[1].width">{{userName}}</td>
                <td [style.width.%]="usageHeaders[2].width"> {{
                  usage.users[userName].tnResults+
                  usage.users[userName].tnFileResults+
                  usage.users[userName].tnRangeResults+
                  usage.users[userName].codeResults+
                  usage.users[userName].npbResults | number
                  }}
                </td>
                <td [style.width.%]="usageHeaders[3].width">{{usage.users[userName].tnResults | number}}</td>
                <td [style.width.%]="usageHeaders[4].width">{{usage.users[userName].tnFileResults | number}}</td>
                <td [style.width.%]="usageHeaders[5].width">{{usage.users[userName].tnRangeResults | number}}</td>
                <td [style.width.%]="usageHeaders[6].width">{{usage.users[userName].codeResults | number}}</td>
                <td [style.width.%]="usageHeaders[7].width">{{usage.users[userName].npbResults | number}}</td>
              </tr>
            </table>

          </td>
        </tr>

      </ng-template>

    </p-table>

  </div>
</div>

